"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KYB_NAMED_GATES = void 0;
exports.KYB_NAMED_GATES = [
    { value: 'kyb_cert_of_incorporation', label: 'Certificate of incorporation' },
    { value: 'kyb_ubo_declaration', label: 'UBO / shareholding declaration' },
    { value: 'kyb_recycling_licence', label: 'Recycling licence' },
    { value: 'kyb_lookup_empty', label: 'Detected lookup returned no candidates' },
];
//# sourceMappingURL=named-gates.js.map